module.exports = __webpack_public_path__ + "static/media/19.24ba69bc.jfif";